export type MessageCheckoutResult = {
  title: string;
  content: string;
  severity: 'success' | 'warning' | 'error';
};

export type UserInfo = {
  profileId: string | null;
  subscriptionId: string | undefined;
  isSubscriber: boolean | null | undefined;
};

export type SubscriptionFormData = {
  cardCVV: string;
  cardExpirationDate: string;
  cardNumber: string;
  cardOwnerName: string;
  cpfCnpj: string;
  turnstileToken: string;
};

export type PhysiciansByAddon = {
  [key: string]: number[];
};

export enum StepTypes {
  ADDRESS = 'address-form',
  PAYMENT = 'payment-form',
  SUCCESS = 'success',
}

export type BillingInfo = {
  person_type: 'pf' | 'pj';
  responsible: string;
  cpf_cnpj: string;
  billing_address: string;
  billing_number: number | string;
  billing_address2: string;
  billing_neighborhood: string;
  billing_city: string;
  billing_state: string;
  billing_zip: string;
  billing_country: string;
  billing_birthdate?: string;
};
